export default "__VITE_ASSET__4348ff12__"